(function () {
  // ボタン内の span を書き換えるユーティリティ
  function setLabel(btn, text) {
    var span = btn.querySelector('span');
    if (span) {
      span.textContent = text;
    } else {
      btn.textContent = text;
    }
  }

  function update(root) {
    root = root || document;

    // 1) 「Pre order」バッジがあるカードを優先的に処理
    var preBadges = root.querySelectorAll('.text-badge.badge-pre');

    preBadges.forEach(function (badge) {
      // バッジのあるカードの最寄りの購入ボタンを探す
      var card = badge.closest('.card-wrapper.product-card-wrapper') || badge.closest('.card');
      if (!card) return;

      // カード内で該当ボタンを探す
      var btn = card.querySelector('button.product-form__submit[name="add"]');

      // 存在しない場合は、ページ内で近い場所にも探しに行く
      if (!btn) {
        btn = badge.closest('section, .shopify-section, body')
                 .querySelector('button.product-form__submit[name="add"]');
      }

      if (!btn) return;

      // ラベルを「予約する」に変える
      setLabel(btn, '予約する');
    });

    // 2) もしバッジがないページ（例：商品ページ）でも対応したい場合
    //    ページ内に「購入する」ボタンがあり、かつ Pre order の商品であれば（タグや他の目印で）変える処理を入れたい時は
    //    ここに追加の条件分岐を書ける。
    //
    //    例：タグやメタフィールドで判定できる場合はここにロジックを入れる。
  }

  // ページ読み込み時に実行
  document.addEventListener('DOMContentLoaded', function () {
    update(document);
  });

  // DOMが途中で差し替えられても追従
  var observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (m) {
      m.addedNodes.forEach(function (node) {
        if (node.nodeType === 1) update(node);
      });
    });
  });

  observer.observe(document.documentElement, { childList: true, subtree: true });
})();
